import ModalActions from "./ModalActions";
import {DialogBody, DialogTitle} from "../catalyst/dialog";

export default function ModalCard ({
  title,
  subTitle,
  children,
  style,
  renderActions,
  className,
  maximized = false,
  onSave,
  noscroll = false,
  disableSave = false,
  disableCancel = false,
  onClose,
  actionsLoading = false,
  saveLabel,
  closeLabel
} : {
  noscroll?: boolean,
  subTitle?: string,
  saveLabel?: string,
  closeLabel?: string,
  disableSave?: boolean,
  disableCancel?: boolean,
  renderActions?: () => void,
  onSave?: () => void,
  onClose?: () => void,
  style?: object,
  maximized?: boolean,
  title?: string,
  children: any,
  className?: string,
  actionsLoading?: boolean
}) {

  return <>
    {
      title &&
        <DialogTitle className={'mb-4'}>
          {title}
        </DialogTitle>
    }
    <DialogBody>
      {children}
    </DialogBody>
    {
      (renderActions) ? renderActions() : <ModalActions
        saveLabel={saveLabel}
        disableCancel={disableCancel}
        closeLabel={closeLabel}
        disableSave={disableSave}
        isLoading={actionsLoading}
        onClose={onClose ? onClose : undefined}
        onSave={onSave ? onSave : undefined}
      />
    }
  </>

}
